/**
* Created by EX_LINYU on 2018-1-15.
* 二次封装iview分页插件
*/
<template>
  <footer>
    <section class="page-main">
      <span>
        <span class="pagedetail">{{$t('page.pagination.pThe')}}
          <span class="bg" v-if="!total">0</span>
          <span class="bg" v-else>{{startPage}}-{{endPage}}</span>&nbsp;{{$t('page.pagination.pOf')}}
          <span class="bg">{{total}}</span>&nbsp;{{$t('page.pagination.pRecord')}}</span>
      </span>
      <span class="page-right">
        <Page size="small" @on-change="onCurrentPageChange" @on-page-size-change="onPageSizeChange" :page-size="myPageSize" :current="page" :page-size-opts="pageSizeOpts" :total="total" :show-elevator="showElevator" :show-sizer="showSizer" placement="top">
        </Page>
      </span>
    </section>
  </footer>
</template>
<style lang="less" scoped>
.page-main {
  margin-top: 10px;
  min-width: 400px;
  .pagedetail {
    font: 400 12px/26px "微软雅黑";
  }
  .page-right {
    float: right;
    padding-right: 0;
  }
  .go {
    height: 28px;
    margin-left: 12px;
    text-align: center;
    margin-top: 2px;
  }
  .el-button--small {
    padding: 7px 4px;
  }
}
</style>
<script>
export default {
  name: 'mPagination',
  props: {
    currentPage: {
        type: Number,
        default: 1
    },
    pageSize: {
        type: Number,
        default: 10
    },
    showElevator: {
      type: Boolean,
      default: true
    },
    showSizer: {
      type: Boolean,
      default: true
    },
    total: {
      type: Number,
      default: 0
    },
    pageSizeOpts: {
      type: Array,
      default() {
        return [10, 30, 50, 80, 100];
      }
    }
  },
  data () {
    return {
      page: this.currentPage,
      myPageSize: this.pageSize
    };
  },
  watch: {
    currentPage (newVal) {
      if (newVal) {
        console.log('currentPage', newVal);
        this.page = newVal;
      }
    },
    pageSize (newVal) {
      if (newVal) {
        this.myPageSize = newVal;
      }
    }
  },
  computed: {
    startPage() {
      return this.myPageSize * (this.page - 1) + 1;
    },
    endPage() {
      /* 总页数小于每页大小或者 当前页数加上每页大小大于总页数 */
      if ((this.myPageSize * (this.page - 1) + 1 + this.myPageSize) > this.total || this.myPageSize > this.total) {
        return this.total;
      }
      return this.myPageSize * (this.page - 1) + this.myPageSize;
    }
  },
  methods: {
    onCurrentPageChange(page) {
      this.page = page;
      this.$emit('on-current-page-change', page);
    },
    onPageSizeChange(pageSize) {
      this.myPageSize = pageSize;
      this.$emit('on-page-size-change', pageSize);
    }
  }
};
</script>
